import _ from 'lodash';
import { joinDataTestId } from '@motili/ui';
import {
    isClientAccount,
    isContractorAccount,
    isMotiliAdmin,
} from '../services/AuthService';

export const getPortalDataTestId = (
    dataTestId: string,
    includeAdmin = false
) => {
    if (_.size(dataTestId) === 0) {
        return '';
    }

    let prefix = '';
    if (isClientAccount()) {
        prefix = 'client';
    }
    if (isContractorAccount()) {
        prefix = 'contractor';
    }
    if (isMotiliAdmin() && includeAdmin) {
        prefix = 'admin';
    }

    return dataTestId.startsWith(`${prefix}-`)
        ? dataTestId
        : joinDataTestId([prefix, dataTestId]);
};
